/** Pure formatting helpers of the desktop shell (sidebar and header badges). */

/** Caps a badge count: 0 / undefined hides it, above 9 shows "9+". */
export function formatBadgeCount(count: number | undefined): string | null {
  if (!count || count <= 0) return null;
  return count > 9 ? "9+" : String(count);
}
